"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Pause = function Pause(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " ").concat(animation)
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.444 4.956c-.012-.016-.024-.032-.04-.044-1-.776-2.2-1.184-3.468-1.184a5.676 5.676 0 00-5.668 5.668 5.636 5.636 0 003.888 5.38 5.72 5.72 0 003.864 1.504 5.758 5.758 0 005.752-5.752 5.76 5.76 0 00-4.328-5.572zm-8.44 4.436A4.937 4.937 0 018.936 4.46a4.92 4.92 0 011.74.324c-3.012.18-5.408 2.68-5.408 5.736 0 1.044.284 2.02.768 2.864a4.896 4.896 0 01-2.032-3.992zm7.012 6.136a4.977 4.977 0 01-3.38-1.324l-.036-.036a4.978 4.978 0 01-1.588-3.648 5.009 5.009 0 015.004-5.004 5.009 5.009 0 015.004 5.004 5.012 5.012 0 01-5.004 5.008z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.159 9.024a.367.367 0 00-.368.368v2.428c0 .204.164.368.368.368a.367.367 0 00.368-.368V9.392a.367.367 0 00-.368-.368zM11.876 9.024a.367.367 0 00-.368.368v2.428c0 .204.164.368.368.368a.367.367 0 00.368-.368V9.392a.37.37 0 00-.368-.368z",
    fill: color
  }));
};
var _default = exports["default"] = Pause;